/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Item } from '../item';
import { TabDescription } from '../tab-description';
import { SystemInfo } from '../system-info';
import { BooleanObject, SysqueElectricalState } from '@hcworkspace/sysque/toolbelt/feature';
import { TooltipItem } from '../tooltip-item';
import { PanelDetails } from 'libs/sysque/toolbelt/feature/src/lib/models/panel-detail';
import { DownloadFamiliesReturnCodes } from 'libs/sysque/toolbelt/feature/src/lib/models/download-families-return-codes';
import { SelectedPanelDataItem } from 'libs/sysque/toolbelt/feature/src/lib/models/selected-panel-data-item';
import { PastedItemsInfo } from '../../../../../feature/src/lib/models/pasted-items-info';

export interface ISystemPanelFrameFacade {
  getSystems(): Observable<SystemInfo[]>;
  getHangerSetUpStatus(): boolean;
  getAddFittingState(): SysqueElectricalState;
  getDockedState(): SysqueElectricalState;
  getFittingsList(system: string, category: string, isSysQueConnect: boolean): Promise<Item[]>
  getCategories(systemName: string): Promise<TabDescription[]>;
  updateLocalStorage(key: string, value: any): any;
  sendPopupRoutingAction(route: string, width: number, height: number): any;
  selectSystems(): Observable<SystemInfo[]>;
  getTooltipItemInfo(item: Item, category: string): TooltipItem[];
  selectDockablePanelList(): Observable<PanelDetails[]>;
  notifyGetDockablePanelListAction(): Promise<PanelDetails[]>;
  getPanelType(systemName: string): Promise<boolean>;
  getCircuitList(projectName: string, panelName: string): Promise<string[]>;
  getLocalStorage(key: string): any;
  openHangerSpecification(): void;
  updateHangerNeeded(systemName: string, isChecked: boolean): Promise<void>;
  selectHangerNeeded(): Observable<BooleanObject>;
  updateClearance(systemName: string, isChecked: boolean): void;
  selectClearance(): Observable<BooleanObject>;
  getProjectList(): void;
  selectProjectList(): Observable<string[]>;
  getWireFillList(projectName: string, categoryName: string): Promise<string[]>;
  updateSystemList(): void;
  getFittings(systemName: string, categoryName: string): Promise<Item[]>;
  downloadUnreferencedFamilies(systemName: string): Observable<boolean>;
  checkIfUnreferencedFamilies(systemName: string): Promise<DownloadFamiliesReturnCodes>;
  getConfigurationLocation(): void;
  applyPanelDataLogic(panelData: SelectedPanelDataItem, isWireFillSpec: boolean): void;
  executePasteItemsAction(replaceItems: PastedItemsInfo[]): Promise<void>;
  checkForDuplicateItems(items: PastedItemsInfo[]): Observable<PastedItemsInfo[]>;
  checkIfCurrentWindowIsDockable(): boolean;
  getSysQueConnectOnState(): boolean;
  
};

export const SYSTEM_PANEL_FRAME_FACADE_TOKEN = new InjectionToken<ISystemPanelFrameFacade>(
  'SYSTEM_PANEL_FRAME_FACADE_TOKEN'
);
